import type { SxProps, Theme } from '@mui/material';

export const selectControlFormSx: SxProps<Theme> = (theme) => ({
  m: '24px',
  minWidth: '220px',
  '& .MuiInputBase-root': {
    minWidth: '220px',
  },
  '& .MuiFormControl-root': {
    width: '100%',
  },
  '& .MuiSelect-root.MuiSelect-select': {
    marginTop: theme.spacing(2),
  },
});
